export const optionList = [
  { value: '利用料金が高いため', label: '利用料金が高いため' },
  { value: '機能に不満があるため', label: '機能に不満があるため' },
  { value: '使い方がわからないため', label: '使い方がわからないため' },
  { value: '画面や操作が難しいため', label: '画面や操作が難しいため' },
  { value: '他サービスを利用するため', label: '他サービスを利用するため' },
  { value: 'サポートに不満があるため', label: 'サポートに不満があるため' }
]
